import { render, staticRenderFns } from "./monitoring-differential-highlighter.html?vue&type=template&id=3501f9b5&scoped=true&"
import script from "./monitoring-differential-highlighter.js?vue&type=script&lang=js&"
export * from "./monitoring-differential-highlighter.js?vue&type=script&lang=js&"
import style0 from "./monitoring-differential-highlighter.scss?vue&type=style&index=0&id=3501f9b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3501f9b5",
  null
  
)

export default component.exports